export const completeString = (string, arr) => {
    for (let i of arr) {
        string = string.replace('%%', i);
    }
    return string
}